






















































import Vue from "vue";
import Component from "vue-class-component";
import ApiFactory from "../../api/ApiFactory";
import { PolicyCountSummaryDto } from "@/api/ClientPortalApiClient";
import { UserStore } from "@/store";
import { FormatDate } from "@/filters/FormatDate";
import { Prop } from "vue-property-decorator";

@Component
export default class PortfolioWidget extends Vue {
  @Prop() contactId: number | undefined;

  private Summary: PolicyCountSummaryDto = new PolicyCountSummaryDto();

  async created() {
    await this.loadPortfolioSummary();
  }

  async loadPortfolioSummary() {
    const api = ApiFactory.CreateDataClient();
    this.Summary = await api.policies_GetSummaryCountByContactId(
      this.ProfileId
    );
  }

  get ProfileId(): number {
    return this.contactId || UserStore.profileId;
  }

  get PortfolioLink(): string {
    return `/Policies/${this.ProfileId}`;
  }
}
